import Login from './Login'  
import RecoverPassword from './components/RecoverPassword' 
function RouteMap(props) {
    const composite = {
    login: <Login /> ,
    recover: <RecoverPassword /> 
    };
return (
<>{composite[props.component]}</>   

);

}
export default RouteMap;